var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCup = function SvgCup(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 20",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.113 13.75v1.75",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.363 18.333h7.5V17.5c0-.917-.675-1.667-1.5-1.667h-4.5c-.825 0-1.5.75-1.5 1.667v.833Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.613 18.333h9M9 13.333c-2.902 0-5.25-2.608-5.25-5.833V5c0-1.842 1.343-3.333 3-3.333h4.5c1.658 0 3 1.491 3 3.333v2.5c0 3.225-2.348 5.833-5.25 5.833Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.103 9.708c-.563-.2-1.058-.566-1.448-1-.675-.833-1.125-1.833-1.125-3 0-1.166.825-2.083 1.875-2.083h.488c-.15.383-.225.808-.225 1.25v2.5c0 .833.157 1.617.435 2.333ZM13.898 9.708c.562-.2 1.057-.566 1.447-1 .675-.833 1.125-1.833 1.125-3 0-1.166-.825-2.083-1.875-2.083h-.488c.15.383.226.808.226 1.25v2.5c0 .833-.158 1.617-.435 2.333Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export { SvgCup as ReactComponent };